<template>
  <div class="page-container">
    <van-cell-group>
      <van-cell>
        <template slot="title" v-if="fcustname">
          <div style="margin-bottom: 10px">学生姓名：{{ fcustname }}</div>
          <template v-if="localAssignments && localAssignments.length > 0">
            <div v-for="item in localAssignments" :key="item.fid ? item.fid : `${item.fteacherid}_${item.fsubjectid}`">
              <van-cell>
                <div slot="title">{{ item.fteachername }}</div>
                <div slot="label">{{ item.fsubjectname }}</div>
                <div>
                  <van-button type="info" size="small" @click="handleChangeTeacher(item)">换老师</van-button>
                  <van-button style="margin-left:10px" type="danger" size="small"
                    @click="handleDelete(item)">删除</van-button>
                </div>
              </van-cell>
            </div>
          </template>
        </template>
      </van-cell>
    </van-cell-group>
    <van-cell-group style="margin-top: 20px">
      <van-cell>
        <div>请分配授课老师及所上科目</div>
        <van-field v-model="selectedValue" readonly clickable placeholder="点击选择授课老师"
          @click="handleOpenTeacherPicker('add')" />
        <van-field v-model="selectedValueSubject" readonly clickable placeholder="点击选择科目"
          @click="showPickerSubject = true" />
        <div style="margin-top: 10px; text-align: center">
          <van-button type="primary" size="small" @click="handleAdd">添加分配</van-button>
        </div>
      </van-cell>
    </van-cell-group>

    <van-popup v-model="showPicker" position="bottom">
      <van-cell-group>
        <van-field label="老师" v-model="searchKeyword" placeholder="输入关键词搜索老师" @input="handleSearch" />
      </van-cell-group>
      <van-picker show-toolbar :columns="filteredColumns" value-key="fname" :default-index="defaultTeacherIndex"
        @confirm="onConfirm" @cancel="showPicker = false" />
    </van-popup>

    <van-popup v-model="showPickerSubject" position="bottom">
      <van-cell-group>
        <van-field label="科目" v-model="searchKeywordSubject" placeholder="输入关键词搜索科目" @input="handleSearchSubject" />
      </van-cell-group>
      <van-picker show-toolbar :columns="filteredSubjectColumns" value-key="fname" @confirm="onConfirmSubject"
        @cancel="showPickerSubject = false" />
    </van-popup>

    <van-button class="bottom-btn" type="info" block @click="handleCopy">
      复制学生已分配信息词条
    </van-button>
  </div>
</template>

<script>
import Vue from 'vue';

import { getUuid } from '@/libs/utils'
import { select, unSelect } from '@/api/public'
import {
  Button, Cell, CellGroup, Picker, Field, Popup, Toast, Dialog
} from 'vant';
Vue.use(Button);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Picker);
Vue.use(Field);
Vue.use(Popup);

export default {
  name: 'edit',
  components: {},
  computed: {},
  created() {
    console.log('created')
  },
  mounted() {
    console.log(this.$route)
    this.fid = this.$route.query.id
    this.loadinit()
  },
  methods: {
    handleCopy() {
      let __params = {}
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      __params.fstudentid = this.fid
      __params.proc_name = 'sp_stu_assignment_info_citiao'
      select(__params).then(res => {
        if (res.data.map.list && res.data.map.list.length > 0) {
          setTimeout(() => {
            this.$copyText(res.data.map.list[0].fwords).then(function () {
              Toast('复制成功')
            }, function () {
              alert('复制失败')
            })
          }, 0); // 延迟0ms即可
        }
        Toast.clear()
      }).catch(err => {
        console.log(err)
        Toast.clear()
      })
    },
    loadinit() {
      let params = {}
      params.proc_name = 'sp_params_oto_subject'
      select(params).then(res => {
        if (res.data.map.list && res.data.map.list.length > 0) {
          this.$store.commit('setSubject', res.data.map.list)
          this.filteredSubjectColumns = [...this.$store.state.user.subject];
        }
      })
      let _params = {}
      _params.proc_name = 'sp_params_oto_teacher'
      select(_params).then(res => {
        if (res.data.map.list && res.data.map.list.length > 0) {
          this.$store.commit('setTeacher', res.data.map.list)
          this.filteredColumns = [...this.$store.state.user.teacher];
        }
      })

      let __params = {}
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      __params.fstudentid = this.fid
      __params.fprojectid = ''
      __params.proc_name = 'sp_stu_assignment_info'
      select(__params).then(res => {
        console.log(res)
        this.localAssignments = res.data.map.list1 || []
        res.data.map.list && res.data.map.list.length > 0 ? this.fcustname = res.data.map.list[0].fcustname : null
        Toast.clear()
      }).catch(err => {
        console.log(err)
        Toast.clear()
      })
    },
    handleSearch() {
      const keyword = this.searchKeyword.trim().toLowerCase();
      this.filteredColumns = this.$store.state.user.teacher.filter(item =>
        item.fname.toLowerCase().includes(keyword))
    },
    handleDelete(item) {
      console.log(item)
      Dialog.confirm({
        title: '删除',
        message: '确认删除已分配的科目及老师',
      })
        .then(() => {
          Toast.loading({
            message: '删除中...',
            forbidClick: true,
          });
          let params = {}
          params.fid = item.fid
          params.fremark = '企业微信端删除'
          params.proc_name = 'sp_stu_assignment_del'
          unSelect(params).then(res => {
            if (res.data.map.result == 1) {
              Toast.success(res.data.map.msg);
              const index = this.localAssignments.findIndex(i =>
                i.fteacherid === item.fteacherid && i.fsubjectid === item.fsubjectid
              );
              if (index !== -1) {
                this.localAssignments.splice(index, 1);
              }
            }
          }).catch(err => {
            console.log(err)
          })
        })
        .catch(() => {
          // on cancel
        });
    },
    handleSearchSubject() {
      const keyword = this.searchKeywordSubject.trim().toLowerCase();
      this.filteredSubjectColumns = this.$store.state.user.subject.filter(item =>
        item.fname.toLowerCase().includes(keyword))
    },
    onConfirm(value) {
      if (this.currentMode === 'change') {
        // 更换老师模式
        this.updateAssignmentTeacher(value);
      } else {
        // 添加分配模式
        this.selectedTeacher = value;
        this.selectedValue = value.fname;
      }
      this.showPicker = false;
      this.searchKeyword = "";
      this.filteredColumns = [...this.$store.state.user.teacher];
    },
    onConfirmSubject(value) {
      this.selectedSubject = value;
      this.selectedValueSubject = value.fname;
      this.showPickerSubject = false;
      this.searchKeywordSubject = "";
      this.filteredSubjectColumns = [...this.$store.state.user.subject];
    },
    handleAdd() {
      if (!this.selectedTeacher || !this.selectedSubject) {
        Toast('请先选择老师和科目');
        return;
      }

      const duplicate = this.localAssignments.some(item =>
        item.fteacherid === this.selectedTeacher.fid &&
        item.fsubjectid === this.selectedSubject.fid
      );

      if (duplicate) {
        Toast('该分配已存在');
        return;
      }
      let params = {

      }
      params.fcustid = this.fid
      params.fid = getUuid()
      params.fteacherid = this.selectedTeacher.fid
      params.fsubjectid = this.selectedSubject.fid
      params.proc_name = 'sp_stu_assignment_add_update'
      Toast.loading({
        message: '提交中...',
        forbidClick: true
      }
      );
      unSelect(params).then(res => {
        Toast.clear();
        if (res.data.map.result == 1) {
          Toast.success(res.data.map.msg || '提交成功');
          this.localAssignments.push({
            fteacherid: this.selectedTeacher.fid,
            fteachername: this.selectedTeacher.fname,
            fsubjectid: this.selectedSubject.fid,
            fsubjectname: this.selectedSubject.fname
          });

          // 清空选择
          this.selectedTeacher = null;
          this.selectedSubject = null;
          this.selectedValue = '';
          this.selectedValueSubject = '';
        } else {
          Toast.fail(res.data.map.msg || '提交失败');
        }
      })


    },
    // 打开老师选择器（统一处理）
    handleOpenTeacherPicker(mode) {
      this.currentMode = mode;
      this.searchKeyword = '';
      this.filteredColumns = [...this.$store.state.user.teacher];
      this.showPicker = true;
    },
    // 换老师功能
    handleChangeTeacher(item) {
      this.currentAssignment = item;
      this.handleOpenTeacherPicker('change');

      // 设置默认选中的老师索引
      const currentTeacherId = item.fteacherid;
      const index = this.filteredColumns.findIndex(teacher => teacher.fid === currentTeacherId);
      this.defaultTeacherIndex = index >= 0 ? index : 0;
    },
    // 更新分配的授课老师
    updateAssignmentTeacher(newTeacher) {
      // Toast.loading('更换中...');
      const params = {
        proc_name: 'sp_stu_assignment_edit',
        fid: this.currentAssignment.fid,
        fteacherid: newTeacher.fid,
        fremark: '企业微信端更换老师'
      };
      unSelect(params).then(res => {
        // Toast.clear();
        if (res.data.map.result == 1) {
          Toast.success('更换老师成功');
          // 更新本地数据
          this.currentAssignment.fteacherid = newTeacher.fid;
          this.currentAssignment.fteachername = newTeacher.fname;
        } else {
          // Toast.fail(res.data.map.msg || '更换老师失败');
        }
      }).catch(err => {
        // Toast.clear();
        Toast.fail('网络错误，更换失败');
        console.error('更换老师失败:', err);
      }).finally(() => {
        this.currentAssignment = null;
      });
    }
  },
  data() {
    return {
      citiaoModal: false,
      fid: null,
      fcustname: null,
      localAssignments: [], // 本地分配列表

      showPickerSubject: false,
      showPicker: false,
      searchKeyword: "",
      searchKeywordSubject: "",
      selectedValue: "",
      selectedValueSubject: "",
      selectedTeacher: null, // 存储选中的老师对象
      selectedSubject: null, // 存储选中的科目对象
      filteredColumns: [],
      filteredSubjectColumns: [],

      // 新增状态变量
      currentMode: null,     // 'add' 或 'change'
      currentAssignment: null, // 当前要更换的分配项
      defaultTeacherIndex: 0 // 老师选择器默认选中索引
    };
  },
}
</script>

<style lang="less" scoped>
.page-container {
  padding: 10px;
  font-weight: bold;
  padding-bottom: 50px;
  /* 避免提交按钮遮挡内容 */
}

.bottom-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 100;
}
</style>